export const BILL_TEXTS = {
    BILL_DETAILS_TEXT: "Bill details",
    BILL_ORDER_ID: "ORDER # {0}",
    BILL_DETAILS: "Bill Details",
    TIP: "Tip",
    ADD_TIP: "Add Tip",
    CLEAR_TIP: "Clear Tip",
    VALUE_RANGE: "Value should be in range between {0}-{1}",
    YOU_PAY: "You Pay",
    ENTER_TIP_TEXT: "Enter tip amount",
    ENTER_CUSTOM_TIP: "Add custom tip 🙌",
};

export enum OnePlanType {
    LITE = "LITE",
    PLUS = "PLUS",
}

export const ONE_PLAN_LOGO_PROPS = {
    [OnePlanType.LITE]: {
        source: "dineout/grayscale_onelite.png",
        imageStyle: {
            width: 65,
            height: 13,
        },
    },
    [OnePlanType.PLUS]: {
        source: "portal/static-assets/icons/one-logotype.png",
        imageStyle: {
            width: 36,
            height: 12,
        },
    },
};
